<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.5861 6H19.4145L13.4144 12.0001L19.4144 18L16.5859 18L12.0002 13.4143L7.41452 18L4.58609 18L10.586 12.0001L4.58594 6H7.41437L12.0002 10.5859L16.5861 6Z"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'HighlightsCancelIcon',
})
</script>
